import { FC, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import CenteredSpin from '@/components/CenteredSpin';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({ children }) => {
  const { t } = useTranslation();
  const { isAuthenticated, isLoading } = useAuth0();
  const location = useLocation();

  // Also accept the SaaS URL token flow (stored in localStorage by init.tsx)
  const hasSaasToken = !!localStorage.getItem('access_token');

  if (isLoading) {
    return <CenteredSpin tip={t('common.loading')} />;
  }

  if (!isAuthenticated && !hasSaasToken) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
